import { FileInput, Image } from "@mantine/core";
import { getBaseUrl } from "../../../graphql/api";
import { useEffect, useState } from "react";
import { FormField } from "../../../helpers/types";

const FileField = ({
   placeHolder,
   isMulti,
   formData,
   options,
   ...rest
}: FormField) => {
   console.log({ name: rest?.name, formData })
   const [preview, setPreview] = useState<string | null>(null);
   function getFile(i: any) {
      if (typeof i === "string") {
         return new File([], i)
      }
      return i
   }
   function getValue() {
      let v = formData?.get(rest?.name);
      if (Array.isArray(v)) {
         v = v.map(getFile)
         return v
      }
      let f = getFile(v)
      return isMulti && f ? [f] : f
   }
   let value = getValue();

   console.log({ value })

   useEffect(() => {
      if (value) {
         try {
            let pFile = Array.isArray(value) ? value[0] : value
            if (!pFile?.size) {
               setPreview(null)
            } else {
               const reader = new FileReader();
               reader.onloadend = () => {
                  setPreview(reader.result as string);
               };
               reader.readAsDataURL(pFile);
            }
         } catch (err) {
            console.error({ value, err })
            setPreview(null)
         }

      }
   }, [value])


   console.log({ FileFieldValue: value })
   let count = 1
   if (value) {
      count = Array.from(value).length
   }
   let imgWidth = parseInt((200 / count).toFixed(0)) - (4 * count)
   return <div className="flex max-w-full flex-col gap-2">
      <FileInput size="xs" accept={options?.accept} readOnly={rest.readOnly} value={value} clearable label={rest.label} onChange={(f: any) => {
         let files = !f ? null : Array.isArray(f) ? f : [f]
         rest?.onChange && rest?.onChange({ currentTarget: { name: rest?.name, files: files } })
      }} capture="environment" multiple={isMulti || false} />
      <div className={`grid grid-cols-${count} gap-2`}>
         {value && Array.from(value).map((f: any) => (<img
            src={preview || `${getBaseUrl()}/uploads/${f?.name}`}
            className={`w-full max-h-[${imgWidth}px] aspect-video object-cover rounded-lg shadow border`}
         />))}
      </div>
   </div>
};

export default FileField;
